import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Error } from '@/components/templates/Error.tsx'
import { ScreenWrapper } from '@/components/templates/ScreenWrapper.tsx'
import { useTrackFormError } from '@/hooks/useTrackFormProgress.ts'
import { useAppointmentStore } from '@/store.ts'
import { xpertTelNumber } from '@/utils/common.ts'

const ErrorScreen = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'errorScreen',
  })
  const navigate = useNavigate()

  const { error, resetStore } = useAppointmentStore()
  useTrackFormError({ error: t(`messages.${error}`) })

  // Determine if we should show phone button for timeout errors
  const showPhoneButton = error === 'timeffTimeoutXpert'
  const phoneNumber = showPhoneButton ? xpertTelNumber : undefined

  return (
    <ScreenWrapper>
      <Error
        error={error}
        phoneNumber={phoneNumber}
        onReset={() => {
          resetStore()
          navigate('/')
        }}
        onBack={() => navigate(-1)}
      />
    </ScreenWrapper>
  )
}

export { ErrorScreen }
